module.exports = __webpack_public_path__ + "img/safe_camical_01.61cc3d8f.jpg";